import { render, staticRenderFns } from "./FactCustomerInfo.vue?vue&type=template&id=30a820d5&scoped=true&"
import script from "./FactCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./FactCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./FactCustomerInfo.vue?vue&type=style&index=0&id=30a820d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a820d5",
  null
  
)

export default component.exports